import actions from './actions'

const initialState = {
  data: [],
  meta: [],
  active: [],
  appCreated: [],
  appSettings: [],
  loading: false,
  appLoadingInProgress: false,
  firstAppCreationInProgress: false,
  firstAppID: 0,
  appsListTotal: 0,
  appSearchText: '',
  appRolesFilter: '',
  appPlanFilter: '',
  appsListPageNo: 1,
  stats: [],
}

export default function appCoreReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
